import store from './store';

export const COOKIE_POLICY_KEY = 'cookie-policy';

export const cookiePolicy = () => store.get(COOKIE_POLICY_KEY) || {},
  getCookiePolicy = function (name) {
    return cookiePolicy()[name] !== false;
  },
  setCookiePolicy = function (newCookiePolicy) {
    store.set(COOKIE_POLICY_KEY, newCookiePolicy);
  },
  deleteCookiePolicy = function () {
    store.remove(COOKIE_POLICY_KEY);
    store.set(COOKIE_POLICY_KEY, { 'cookie-notification': false });
  };

export const regions = [
  'US-CA',
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
];

export function setWindowCookieActions() {
  window.cookiePolicyAnswer = function (name) {
    return getCookiePolicy(name);
  };

  window.setCookie = function (name, value) {
    document.cookie = name + '=' + value + ';';
  };

  window.getCookie = function (name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
  };
}

export function DOMContentLoadedCookieHandler() {
  let cookieStatus = 'granted';
  setConsentSetting('consent', 'default', {
    ad_storage: cookieStatus,
    ad_user_data: cookieStatus,
    ad_personalization: cookieStatus,
    analytics_storage: cookieStatus,
  });

  const cookiePopup = document.getElementById('cookies-popup-div');
  const isVisited = store.get('cookiesVisited');

  if ((cookiePolicy()['cookie-notification'] === false || isVisited) && cookiePopup) {
    cookiePopup.remove();
  }

  if (cookiePolicy()['targeting'] === false) {
    cookieStatus = 'denied';
  }

  changeCookieStatus(cookieStatus);

  if (document.getElementsByClassName('js-cookies-accept').length) {
    document.getElementsByClassName('js-cookies-accept')[0].addEventListener('click', function (e) {
      e.preventDefault();

      deleteCookiePolicy();
      cookieStatus = 'granted';
      changeCookieStatus(cookieStatus);

      cookiePopup && cookiePopup.remove();
      return false;
    });
  }
}

window.dataLayer = window.dataLayer || [];
export function setConsentSetting() {
  dataLayer.push(arguments);
}

export function updateConsentSetting(cookieStatus) {
  setConsentSetting('consent', 'update', {
    ad_storage: cookieStatus,
    ad_user_data: cookieStatus,
    ad_personalization: cookieStatus,
    analytics_storage: cookieStatus,
    region: regions,
  });
}

export function changeCookieStatus(cookieStatus) {
  window.setCookie('ad_storage', cookieStatus);
  window.setCookie('ad_user_data', cookieStatus);
  window.setCookie('ad_personalization', cookieStatus);
  window.setCookie('analytics_storage', cookieStatus);
  updateConsentSetting(cookieStatus);
}
